<template>
  <div>
    <div
      class="drawFun"
      v-for="(fun,index) in drawFunResource"
      :key="index"
      @click="chooseFun(index)"
      @mouseover="enterEffect(index)"
      @mouseout="leaveEffect(index)"
    >
      <div class="drawIcon" ref="icon" :id="fun.id">
        <img ref="img" :src="fun.url1" :id="fun.id" alt />
      </div>

      <div class="drawText" ref="text" :id="fun.id">{{fun.name}}</div>
    </div>
  </div>
</template> 

<script>
export default {
  data() {
    return {
      drawFunResource: [
        {
          name: "绘线",
          url1: require(`@/assets/views/map/icon/line.png`),
          url2: require(`@/assets/views/map/icon/isline.png`)
        },
        {
          name: "加点",
          url1: require(`@/assets/views/map/icon/point.png`),
          url2: require(`@/assets/views/map/icon/ispoint.png`)
        },
        {
          name: "吸附",
          url1: require(`@/assets/views/map/icon/adsorb.png`),
          url2: require(`@/assets/views/map/icon/isadsorb.png`)
        },
        {
          name: "撤销",
          url1: require(`@/assets/views/map/icon/undo.png`),
          url2: require(`@/assets/views/map/icon/isundo.png`)
        },
        {
          name: "删除",
          url1: require(`@/assets/views/map/icon/delete.png`),
          url2: require(`@/assets/views/map/icon/isdelete.png`)
        }
      ],
      hoverIndex: 0,
      chooseIndex: []
    };
  },
  methods: {
    inStyle(index) {
      const color = "#08CE82";
      this.$refs.icon[index].style.borderColor = color;
      this.$refs.text[index].style.color = color;
      this.$refs.img[index].src = this.drawFunResource[index].url2;
    },
    outStyle(index) {
      const color = "#adadad";
      this.$refs.icon[index].style.borderColor = color;
      this.$refs.text[index].style.color = color;
      this.$refs.img[index].src = this.drawFunResource[index].url1;
    },

    enterEffect(index) {
      // console.log(e);
      this.hoverIndex = index;
      this.inStyle(index);
    },
    leaveEffect(index) {
      if (this.chooseIndex.includes(index)) return;
      this.outStyle(this.hoverIndex);
    },
    chooseICon(index) {
      this.$refs.img[index].bool = !0;
      this.$refs.icon[index].bool = !0;
      this.$refs.text[index].bool = !0;
    },
    giveupIcon(index) {
      this.chooseIndex.splice(this.chooseIndex.indexOf(index), 1);
    },
    chooseFun(index) {
      // e.preventDefault();
      // console.log(this.hoverIndex);

      if (this.chooseIndex.includes(index)) {
        this.chooseIndex.splice(this.chooseIndex.indexOf(index), 1);
        this.$emit("chooseFun", index);
        this.outStyle(index);
      } else {
        this.$emit("chooseFun", index);
        if (index > 2) return;

        this.chooseIndex.push(index);
        this.inStyle(index);
        if (index === 1 && this.chooseIndex.includes(0)) {
          this.chooseIndex.splice(this.chooseIndex.indexOf(0), 1);
          this.$emit("chooseFun", 0);
          this.outStyle(0);
        } else if (index === 0 && this.chooseIndex.includes(1)) {
          this.chooseIndex.splice(this.chooseIndex.indexOf(1), 1);
           this.$emit("chooseFun", 1);
          this.outStyle(1);
        }
      }
    }
  }
};
</script>
<style lang='scss' scoped>
@import url("../stylus/draw.scss");
</style>